import CloseIcon from "@mui/icons-material/Close";
import { useFeatureGate } from "@statsig/react-bindings";

import { IconButton } from "@/Components/v2/atoms/Button";
import { Dialog, DialogContent } from "@/Components/v2/atoms/Dialog";
import { featureFlag } from "@/context/FeatureFlagProvider/featureFlags";
import { useAnalytics } from "@/hooks/useAnalytics";
import { ScenarioTypeEnum } from "@/pages/scenario-builder/types";
import {
  CreateScenarioOptions as CreateScenarioOptionsType,
  CreateScenarioResponse,
  useCreateScenario,
} from "@/pages/scenario-builder/v3/api/createScenario";

import CreateScenarioOptions from "../../components/create-scenario-options/CreateScenarioOptions";
import { useScenariosV3Routes } from "../../hooks/useScenariosV3Routes";

type NewScenarioModalPageProps = {
  open: boolean;
  handleClose: () => void;
};

export const NewScenarioModalPage = ({ open, handleClose }: NewScenarioModalPageProps) => {
  const { scenarioCreated } = useAnalytics();
  const { navigateToScenarioForm } = useScenariosV3Routes();

  const { value: isScenariosApiEnabled } = useFeatureGate(featureFlag.scenarioBuilderApi);

  const createScenarioMutation = useCreateScenario({
    isScenariosApiEnabled,
    config: {
      onSuccess: (result: CreateScenarioResponse) => {
        if (result.uuid) {
          scenarioCreated({
            scenarioType: result.scenarioType,
            scenarioId: result.uuid,
            scenarioName: result.name || "Untitled Scenario",
            isCloned: false,
          });

          navigateToScenarioForm(result.uuid);
        }
      },
    },
  });

  const handleCreateScenario =
    (scenarioType: ScenarioTypeEnum, options?: CreateScenarioOptionsType) => () => {
      const email = JSON.parse(localStorage.getItem("user") || "{}").email;
      if (!email) {
        window.location.reload();
        return;
      }
      createScenarioMutation.mutate({
        scenarioType,
        createdBy: email,
        name: options?.name ?? "Untitled Scenario",
        scenarioCount: options?.scenarioCount ?? null,
      });
    };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: "80rem",
        },
      }}
    >
      <DialogContent>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <CreateScenarioOptions onClick={handleCreateScenario} />
      </DialogContent>
    </Dialog>
  );
};

export default NewScenarioModalPage;
